import { render, staticRenderFns } from "./CarouselItem.vue?vue&type=template&id=12cbf59c&scoped=true&"
import script from "./CarouselItem.vue?vue&type=script&lang=ts&"
export * from "./CarouselItem.vue?vue&type=script&lang=ts&"
import style0 from "./CarouselItem.vue?vue&type=style&index=0&id=12cbf59c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cbf59c",
  null
  
)

export default component.exports